export default __webpack_public_path__ + "static/media/flag_icon.273c88f8.svg";